import { replacePathParams } from '@/api/utils';

export const orchestratorApiPaths = {
  reserveResource: '/apiorchestrator/cases/:caseId/resources/reserve',
  removeResourceReservation: '/apiorchestrator/cases/:caseId/resources/remove-reservation',
  bookResources: '/apiorchestrator/cases/:caseId/resources/book',
  bookSpecificResources: '/apiorchestrator/cases/:caseId/resources/book/specific',
  switchConsole: '/apiorchestrator/cases/:caseId/ocsconsoles/switch',
  transferResources: '/apiorchestrator/cases/resources/transfer',
  transferReallocation: '/apiorchestrator/cases/transfer-reallocation-data',
  switchClinicalSpecialist: '/apiorchestrator/cases/:caseId/clinical-specialists/switch',
  checkOperationStatus: '/apiorchestrator/operations/:correlationId',
  hospitalContactById: '/apiorchestrator/hospitals/contacts/:contactId',
  opoContactById: '/apiorchestrator/opos/contacts/:contactId',
  opoById: '/apiorchestrator/opos/:opoId',
  customerById: '/apiorchestrator/customers/:customerId',
  hospitalById: '/apiorchestrator/hospitals/:hospitalId',
  tXCenterById: '/apiorchestrator/txcenters/:txcenterId',
  hubById: '/apiorchestrator/hubs/:hubId',
} as const;

export const getOrchestratorApiUrl = {
  reserveResource: (caseId: string) => replacePathParams(orchestratorApiPaths.reserveResource, { caseId }),
  removeResourceReservation: (caseId: string) =>
    replacePathParams(orchestratorApiPaths.removeResourceReservation, { caseId }),
  bookResources: (caseId: string) => replacePathParams(orchestratorApiPaths.bookResources, { caseId }),
  bookSpecificResources: (caseId: string) => replacePathParams(orchestratorApiPaths.bookSpecificResources, { caseId }),
  switchConsole: (caseId: string) => replacePathParams(orchestratorApiPaths.switchConsole, { caseId }),
  transferResources: () => orchestratorApiPaths.transferResources,
  switchClinicalSpecialist: (caseId: string) =>
    replacePathParams(orchestratorApiPaths.switchClinicalSpecialist, { caseId }),
  checkOperationStatus: (correlationId: string) =>
    replacePathParams(orchestratorApiPaths.checkOperationStatus, { correlationId }),
  removeHospitalContactById: (contactId: string) =>
    replacePathParams(orchestratorApiPaths.hospitalContactById, { contactId }),
  removeOpoContactById: (contactId: string) => replacePathParams(orchestratorApiPaths.opoContactById, { contactId }),
  removeOpoById: (opoId: string) => replacePathParams(orchestratorApiPaths.opoById, { opoId }),
  removeCustomerById: (customerId: string) => replacePathParams(orchestratorApiPaths.customerById, { customerId }),
  removeHospitalById: (hospitalId: string) => replacePathParams(orchestratorApiPaths.hospitalById, { hospitalId }),
  removeTXCenterById: (txcenterId: string) => replacePathParams(orchestratorApiPaths.tXCenterById, { txcenterId }),
  hubById: (hubId: string) => replacePathParams(orchestratorApiPaths.hubById, { hubId }),
  transferReallocation: () => orchestratorApiPaths.transferReallocation,
};
